angular.module('callX').service('ReportsService', ['$http', '$rootScope', 'UserService',
  function ($http, $rootScope, UserService){

    var getDashboardTopData = function(dataType, activeDate, dateRangeValue, callbacks){
      var currentUserData = UserService.getCurrentUserData();
      var _data = {
        id: currentUserData.id,
        type: dataType,
        ref: activeDate,
        ref_from: dateRangeValue[0],
        ref_to: dateRangeValue[1]
      };
      $http.get("/japi/report/v1/publisher", {params: _data})
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getGraphAndTableData = function(dataType, activeDate, dateRangeValue, rankBy, callbacks){
      var currentUserData = UserService.getCurrentUserData();
      var _data = {
        id: currentUserData.id,
        type: dataType,
        rank: rankBy,
        ref: activeDate,
        ref_from: dateRangeValue[0],
        ref_to: dateRangeValue[1]
      };
      $http.get("/japi/report-chart/v1/publisher", {params: _data})
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getPromoGranularData = function(userId, dataType, activeDate, dateRangeValue, rankBy, gId, callType, state, dayPart, callbacks){
      var _data = {
        id: userId,
        type: dataType,
        rank: rankBy,
        ref: activeDate,
        ref_from: dateRangeValue[0],
        ref_to: dateRangeValue[1],
        sid:gId,
        call_type: callType
      };
      _data.rank = 'calls';
      if(dayPart == 0 || dayPart == undefined || dayPart == 'undefined' || dayPart == 'null' || dayPart == null || dayPart == ''){
        _data.daypart = 0;
      }
      else
      {
        _data.daypart = dayPart;
      }
      if(state!=undefined && state!='null' && state!=null && state!='' && state != 'other'){
        _data.state = state;
      }
      else
      {
        _data.state = null;
      }
//      console.log("_data",_data);
      $http.get("/japi/report-chart-granular/v1/publisher", {params: _data})
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getGeoData = function(userId, dataType, dateReference, dateRangeValue, gId, callbacks){
      var _data = {
        id: userId,
        type: dataType,
        rank: 'calls',
        ref: dateReference,
        ref_from: dateRangeValue[0],
        ref_to: dateRangeValue[1],
        sid:gId
      };
      $http.get("/japi/report-chart-state/v1/publisher", {params: _data})
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getDayPartData = function(userId, dataType, dateReference, dateRangeValue, gId, callbacks){
      var _data = {
        id: userId,
        type: dataType,
        rank: 'calls',
        ref: dateReference,
        ref_from: dateRangeValue[0],
        ref_to: dateRangeValue[1],
        sid:gId
      };
      $http.get("/japi/report-chart-daypart/v1/publisher", {params: _data})
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    return {
      getDashboardTopData: function (dataType, activeDate, dateRangeValue, callbacks) {
        getDashboardTopData(dataType, activeDate, dateRangeValue, callbacks);
      },
      getGraphAndTableData: function (dataType, activeDate, dateRangeValue, rankBy, callbacks) {
        getGraphAndTableData(dataType, activeDate, dateRangeValue, rankBy, callbacks);
      },
      getPromoGranularData: function (userId, dataType, activeDate, dateRangeValue, rankBy, gId, callType, state, dayPart, callbacks) {
        getPromoGranularData(userId, dataType, activeDate, dateRangeValue, rankBy, gId, callType, state, dayPart, callbacks);
      },
      getGeoData: function (userId, dataType, dateReference, dateRangeValue, gId, callbacks) {
        getGeoData(userId, dataType, dateReference, dateRangeValue, gId, callbacks);
      },
      getDayPartData: function (userId, dataType, dateReference, dateRangeValue, gId, callbacks) {
        getDayPartData(userId, dataType, dateReference, dateRangeValue, gId, callbacks);
      }
    };
  }]);